var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 51.563,
    viewBox: "0 0 60 51.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-credit-card-2386312",
    d: "M3.516,4.5A3.519,3.519,0,0,0,0,8.016V33.8a3.519,3.519,0,0,0,3.516,3.516H7.734V52.547a3.519,3.519,0,0,0,3.516,3.516H56.484A3.519,3.519,0,0,0,60,52.547V26.766a3.519,3.519,0,0,0-3.516-3.516H52.266V8.016A3.519,3.519,0,0,0,48.75,4.5Zm0,2.344H48.75a1.174,1.174,0,0,1,1.172,1.172v3.516H2.344V8.016A1.174,1.174,0,0,1,3.516,6.844ZM2.344,18.563H49.922V23.25H11.25a3.519,3.519,0,0,0-3.516,3.516v8.2H3.516A1.174,1.174,0,0,1,2.344,33.8Zm8.906,7.031H56.484a1.174,1.174,0,0,1,1.172,1.172V52.547a1.174,1.174,0,0,1-1.172,1.172H11.25a1.174,1.174,0,0,1-1.172-1.172V26.766A1.174,1.174,0,0,1,11.25,25.594Zm28.125,4.688A5.859,5.859,0,1,0,42.89,40.826a5.859,5.859,0,1,0,0-9.371,5.858,5.858,0,0,0-3.515-1.174Zm0,2.344a3.514,3.514,0,0,1,2.635,1.191h0a3.514,3.514,0,1,1-2.636-1.193Zm7.031,0a3.516,3.516,0,1,1-1.954,6.437,5.848,5.848,0,0,0,0-5.842A3.517,3.517,0,0,1,46.406,32.625Z",
    transform: "translate(0 -4.5)",
    fill: "#ffaa2f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.db2a49c5431a0e20b51349c7f96b0499.svg";
export { ForwardRef as ReactComponent };